import Container from "react-bootstrap/Container";
// import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import BtnAzkary from "../Components/Btn-azkary";
// Get Styles
import styles from "./../styles/login.module.css";
import { motion } from "framer-motion";

function NavbarC() {

  
  return (
    <Navbar className={`z-50 ${styles.navTop} sticky-top`} expand="lg">
      <Container className="text-white relative">
        <BtnAzkary />

        <Navbar.Collapse
          className={`mt-5 text-center ${styles.navHeden}`}
          id="basic-navbar-nav "
        >
          <Link
            className={`${styles.homeLink} ms-auto text-decoration-none fs-4 hover:text-gray-300`}
            to="/"
          >
            <motion.p
              initial={{ x: "-100vw" }}
              animate={{ x: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className={`${window.innerWidth >= 992 ? "ms-5" : ""} `}
            >
              الصفحة الرئيسية
            </motion.p>
          </Link>
          <motion.nav
            initial={{ x: "-100vw" }}
            animate={{ x: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="ms-auto text-center flex gap-2"
          >
            <Link
              className={`${styles.login} mt-2 text-decoration-none font-semibold hover:text-gray-600 px-2 py-2 text-gray-600`}
              to="/login"
            >
              تسجيل دخول
            </Link>
            <Link
              className={`${styles.login2} mt-2 text-decoration-none font-semibold hover:text-gray-600 py-2 px-2`}
              to="/signup"
            >
              انشاء حساب
            </Link>
          </motion.nav>
        </Navbar.Collapse>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="text-white "
        />
      </Container>
    </Navbar>
  );

}

export default NavbarC;
